import ListCRUD from "mrf/view/ListCRUD";
import React from "react";
import dateTimeFormatter from "mrf/utils/DateTimeFormatter";

export default function UserHistory() {
    const UserHistoryType = Object.freeze({
        UserCreated: 0,
        RoleAdded: 1,
        RoleRemoved: 2,
        UserEnabled: 3,
        UserDisabled: 4,
        TwoFactorEnabled: 5,
        TwoFactorDisabled: 6,
    });
    
    const fields = [
        { name: 'Timestamp', key: 'recordTimestamp', map: t => dateTimeFormatter(t, 'L LTS')},
        { name: 'Action Type', key: 'type', map: t => Object.keys(UserHistoryType).find(name => UserHistoryType[name] === t) },
        { name: 'Request Username', keys: ['recordUser', 'userName'], },
        { name: 'Target Username', keys: ['user', 'userName'], },
        { name: 'Role', keys: ['role', 'code'], },
    ];

    return <ListCRUD
        singular='userHistory'
        fields={fields}
        disableNewButton
        disableViewButton
        disableEditButton
    />;
}